import { inject, InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ActionOwner, ActionOwnerData } from '../actions.model';
import { UnresolvedActionOwnerService } from './unresolved-action-owner.service';

export interface ActionOwnerApi {
  loadOwners(): Observable<ActionOwnerData>;
  resolveOwner(ownerId: string): Observable<ActionOwner | null>;
}

export const ACTION_OWNER_API = new InjectionToken<ActionOwnerApi>(
  'ACTION_OWNER_API',
  {
    providedIn: 'root',
    factory: () => inject(UnresolvedActionOwnerService),
  },
);
